/**
 * Calculates the discount amount based on type and value.
 * @param subtotal - The subtotal amount before discount
 * @param discountType - 1 for Amount, 2 for Percentage
 * @param discountValue - The discount value (amount or percentage)
 * @returns The calculated discount amount
 */
export const calculateDiscountAmount = (
  subtotal: number,
  discountType: number,
  discountValue: number
): number => {
  if (discountType === 2) {
    // Percentage
    return (subtotal * discountValue) / 100;
  }
  // Amount (type 1 or default)
  return discountValue;
};

/**
 * Discount type constants
 */
export const DiscountType = {
  AMOUNT: 1,
  PERCENTAGE: 2,
} as const;

export type DiscountTypeValue = typeof DiscountType[keyof typeof DiscountType];
